import {
    SHOW_MODAL
} from '../actions/types'

const initialState = {
    showModal: false
};

const modalReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_MODAL:
            return {
                ...state,
                showModal: action.payload
            }
        default:
            return state
    }
}

export default modalReducer;